import { atom } from 'jotai';

import type { Survey } from '@/hooks/react-query/webinar';
import { deepCopy } from '@/lib/utils/businessLogics/utils/_helper';

export type WebinarOrientation = {
  name: string;
  phone: string;
  email: string;
  question: string;
  survey: Survey[];
};

export const InitOrientationValue: WebinarOrientation = {
  name: '',
  phone: '',
  email: '',
  question: '',
  survey: [
    {
      question: 'Q1. 현재 상황을 알려주세요.',
      answer: '',
    },
    {
      question: 'Q2. 개발자 취업을 준비하며 가장 어려운 점은 무엇인가요?',
      answer: '',
    },
    {
      question: 'Q3. 목표로 하는 취업/이직 시기를 알려주세요.',
      answer: '',
    },
  ],
};
export const webinarOrientationAtom = atom<WebinarOrientation>(
  deepCopy<WebinarOrientation>(InitOrientationValue),
);
